import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const ChatSettingSkeleton = memo(() => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 lg:gap-7.5 mb-[20px]">
      <div className="col-span-2">
        <SettingCardSkeleton
          titleWidth={120}
          controls={["input", "input", "input"]}
          showFooter
        />
      </div>
    </div>
  );
});

ChatSettingSkeleton.displayName = "ChatSettingSkeleton";

export default ChatSettingSkeleton;
